module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"title":"Матрицы корреспонденций"},"en":{"title":"Correspondence matrices"}}')
  delete Component.options._Ctor
}
